import React from 'react';
import Icon from '../../../components/AppIcon';

const AlertPanel = ({ alerts }) => {
  const getSeverityColor = (severity) => {
    switch (severity) {
      case 'critical':
        return 'bg-error/10 border-error/20 text-error';
      case 'warning':
        return 'bg-warning/10 border-warning/20 text-warning-foreground';
      case 'info':
        return 'bg-primary/10 border-primary/20 text-primary';
      default:
        return 'bg-muted border-border text-muted-foreground';
    }
  };

  const getSeverityIcon = (severity) => {
    switch (severity) {
      case 'critical':
        return 'AlertCircle';
      case 'warning':
        return 'AlertTriangle';
      case 'info':
        return 'Info';
      default:
        return 'Bell';
    }
  };

  if (!alerts || alerts?.length === 0) {
    return (
      <div className="bg-card rounded-lg border border-border p-24 text-center">
        <Icon 
          name="CheckCircle2" 
          size={48} 
          color="var(--color-success)" 
          strokeWidth={2}
          className="mx-auto mb-12" 
        />
        <p className="font-body text-[14px] text-muted-foreground">
          No active alerts. All systems operating normally.
        </p>
      </div>
    );
  }

  return (
    <div className="bg-card rounded-lg border border-border overflow-hidden">
      <div className="p-18 md:p-24 border-b border-border">
        <div className="flex items-center gap-12">
          <Icon name="Bell" size={20} color="var(--color-primary)" strokeWidth={2} />
          <h3 className="font-heading font-semibold text-base md:text-lg text-foreground">
            Active Alerts
          </h3>
          <span className="ml-auto px-12 py-4 bg-error/10 rounded-full font-caption font-semibold text-[12px] text-error">
            {alerts?.length}
          </span>
        </div>
      </div>
      <div className="divide-y divide-border max-h-[400px] overflow-y-auto">
        {alerts?.map((alert) => (
          <div
            key={alert?.id}
            className={`
              p-18 md:p-24 border-l-4 transition-smooth hover:bg-muted/50
              ${getSeverityColor(alert?.severity)}
            `}
          >
            <div className="flex items-start gap-12">
              <Icon
                name={getSeverityIcon(alert?.severity)}
                size={20}
                color="currentColor"
                strokeWidth={2}
                className="flex-shrink-0 mt-[2px]"
              />
              <div className="flex-1 min-w-0">
                <h4 className="font-body font-semibold text-[14px] md:text-[15px] text-foreground mb-6">
                  {alert?.title}
                </h4>
                <p className="font-body text-[13px] md:text-[14px] text-muted-foreground mb-8">
                  {alert?.message}
                </p>
                <div className="flex items-center gap-12 flex-wrap">
                  <span className="font-caption text-[12px] text-muted-foreground">
                    {alert?.timestamp}
                  </span>
                  {alert?.source && (
                    <>
                      <span className="text-muted-foreground">•</span>
                      <span className="font-caption text-[12px] text-muted-foreground">
                        {alert?.source}
                      </span>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AlertPanel;